<script setup>
import { computed } from "vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonRadio from "@/components/ArgonRadio.vue";
import ArgonLoadingButton from "@/components/ArgonLoadingButton.vue";

const props = defineProps({
  name: {
    type: String,
    default: "",
  },
  nameError: {
    type: Boolean,
    default: false,
  },
  closePreviousPlansOption: {
    type: String,
    default: "NO",
  },
  disableButton: {
    type: Boolean,
    default: false,
  },
  loadingVehicles: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  "update:name",  
  "update:closePreviousPlansOption",
  "prev",
  "save"
]);

const nameModel = computed({
  get() {
    return props.name;
  },
  set(value) {
    emit("update:name", value);
  },
});
 
const closePreviousPlansOptionModel = computed({
  get() {
    return props.closePreviousPlansOption;
  },
  set(value) {
    emit("update:closePreviousPlansOption", value);
  },
});
</script>

<template>
  <div
    class="multisteps-form__panel js-active p-2 position-relative bg-white rounded-3"
    data-animation="FadeIn"
  >
    <div class=" d-flex flex-column" style="min-height: 300px;">
      <div class="text-center mb-2">
        <p class="mb-0">Indica el nombre para el nuevo plan</p>
      </div>

      <div class="row justify-content-center">
        <div class="col-12 col-md-4">
          <argon-input
            id="plan-name"
            v-model="nameModel"
            :error="nameError"
            :max-length="20"
          />
        </div>
      </div>

    
      <div class="text-center mt-3 mb-2">
        <p class="mb-0">¿Quieres cerrar los planes abiertos de paradas de días anteriores?</p>
      </div>

      <div class="d-flex justify-content-center gap-4 text-center">
        <div class="d-inline-flex align-items-center gap-2 mb-0">
          <span>No</span>
          <argon-radio
            id="plan-close-previous-open-plans-no"
            v-model="closePreviousPlansOptionModel"
            name="NO"
            group-name="plan-close-previous-open-plans"
          />
        </div>

        <div class="d-inline-flex align-items-center gap-2 mb-0">
          <span>Si</span>
          <argon-radio
            id="plan-close-previous-open-plans-yes"
            v-model="closePreviousPlansOptionModel"
            name="SI"
            group-name="plan-close-previous-open-plans"
          />
        </div>
      </div>

      <div class="d-flex mt-auto">
        <argon-button
          class="mb-0 btn-icon-only"
          color="primary"
          variant="outline"
          size="xs"
          aria-label="Anterior"
          @click.prevent="emit('prev')"
        >
          <span class="btn-inner--icon">
            <i class="fas fa-chevron-left" aria-hidden="true"></i>
          </span>
        </argon-button>
        <argon-loading-button
          class="ms-auto mb-0"
          color="primary"
          variant="gradient"
          size="xs"
          :label="disableButton ? 'Creando...' : 'Aceptar'"
          :loading="disableButton"
          :disable-button="disableButton || loadingVehicles"
          @click.prevent="emit('save')"
        />
      </div>
    </div>
  </div>
</template>

 
